<template>
    <button
        ref="smallButtonRef"
        class="small-button"
        :class="[styleVariant, { loading: loading }]"
        v-bind="$attrs"
        type="button"
        @click="removeFocus()"
    >
        <div v-if="loading">
            <loading class="loading" />
        </div>
        <div v-else class="button-content">
            <div class="icon">
                <slot name="icon" />
            </div>
            <div class="label">
                <slot />
            </div>
        </div>
    </button>
</template>

<script setup>
import { computed, ref } from 'vue';
import { Loading } from 'ihunter-pathfinder-components';

const props = defineProps({
    // Variant: primary, secondary, critical, success
    variant: {
        type: String,
        default: 'primary',
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const styleVariant = computed(() => {
    return props.variant;
});

const smallButtonRef = ref(null);

function removeFocus() {
    requestAnimationFrame(() => {
        smallButtonRef.value?.blur();
    });
}
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use 'ihunter-pathfinder/styles/buttons' as PathfinderButton;

.small-button {
    @include PathfinderButton.Button;

    // Apply style to slot image
    height: Pathfinder.$button-height-small;
    width: fit-content;

    &.loading {
        ::v-deep(svg) {
            max-width: 62px;
        }
    }
}
</style>
